var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 lg:px-3 m-auto"},[_vm._v(" PageDefault "+_vm._s(_vm.currentPage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }